import api from './api';

export const getFileAuditTrail = (fileId) =>
  api.get(`/files/${fileId}/audit-trail`);

export const listExternalShareGrants = (fileId) =>
  api.get(`/files/${fileId}/external-shares`);

export const createExternalShareGrant = (fileId, data) =>
  api.post(`/files/${fileId}/external-shares`, data);

export const revokeExternalShareGrant = (fileId, grantId) =>
  api.delete(`/files/${fileId}/external-shares/${grantId}`);

export const accessExternalShareByToken = (token) =>
  api.get(`/external-shares/${token}`);
